import React from 'react'
import { Button } from 'react-bootstrap'
import CommonButton from '../Desktop/SubComponents/CommonButton'
const DonationMb = () => {
  return (
    <>
        <div className="donationmb" data-aos-delay="400" data-aos="fade-up" data-aos-duration="2000">
            <div className="mycontainermb">
                <h4 className='subheading'>Care for a donation!</h4>

                <div className="picframe ms-auto">
                        <img className='w-100' src="./assets/images/Mobile/HomepageMb/donation/donationmb.png" alt="" />
                </div>

                <p>Lorem ipsum dolor sit amet consectetur. Neque mauris massa mauris et dui volutpat nunc purus felis. Est vitae et velit at. Interdum sodales gravida mattis venenatis fusce sagittis quisque.</p>

                <div className="iconwithtext">
                                <div className="icon">
                                    <img src="./assets/images/Homepage/donation/smallicon1.png" alt="smallicon1.png" />
                                </div>
                                <div className="textpartright">
                                    <p>Ut et imperdiet tempor eget sed. Eu augue consectetur adipiscing neque mauris placerat nec diam.</p>
                                </div>
                            </div>
                            <div className="iconwithtext">
                                <div className="icon">
                                    <img src="./assets/images/Homepage/donation/smallicon1.png" alt="smallicon1.png" />
                                </div>
                                <div className="textpartright">
                                    <p>Sit etiam sed egestas enim. Turpis sed ante facilisi sapien dictum. Ultrices elementum</p>
                                </div>
                            </div>
                            <div className="buttondiv d-flex justify-content-center">
                                <CommonButton text="Donate Now"/>
                                <Button>Learn More</Button>
                            </div>
            </div>
        </div>
    </>
  )
}

export default DonationMb